export default __webpack_public_path__ + "static/media/view-appointment.212950ff.webp";